module.exports = __webpack_public_path__ + "img/BTCZ.48ccfe8f.svg";